import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  Output,
  OnInit,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  TuiButtonModule,
  TuiGroupModule,
  TuiTextfieldControllerModule,
} from '@taiga-ui/core';
import { AutocompleteComponent } from '@shared/components/forms/autocomplete/autocomplete.component';
import { TuiInputModule, TuiInputNumberModule } from '@taiga-ui/kit';
import { CargoCatalogsService } from '@shared/services/cargo-catalogs.service';
import { AsyncPipe } from '@angular/common';
import { tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FactPackageTypeForm } from '../../../../../../types/cargo';

@Component({
  selector: 'app-fact-package-type-form',
  standalone: true,
  imports: [
    TuiGroupModule,
    AutocompleteComponent,
    ReactiveFormsModule,
    TuiTextfieldControllerModule,
    TuiButtonModule,
    TuiInputNumberModule,
    TuiInputModule,
    AsyncPipe,
  ],
  templateUrl: './fact-package-type-form.component.html',
  styleUrl: './fact-package-type-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FactPackageTypeFormComponent implements OnInit {
  @Input({ required: true })
  factPackageTypeForm: FormGroup<FactPackageTypeForm>;

  @Input({ required: true }) cargoPlaceId: Nullable<number>;
  @Input({ required: true }) last: boolean;
  @Output() create = new EventEmitter();
  @Output() remove = new EventEmitter();
  constructor(
    protected readonly catalogs: CargoCatalogsService,
    private readonly destroyRef: DestroyRef,
  ) {}

  onPackageTypeChange() {
    this.factPackageTypeForm.controls.packageTypeJson.controls.code.valueChanges
      .pipe(
        tap(packageType => {
          this.updatePackageDetails(packageType);
        }),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe();
  }

  updatePackageDetails(packageTypeCode: Nullable<string>) {
    const packageDetails = this.catalogs.packageTypesMap.get(
      packageTypeCode || '',
    );
    if (packageDetails) {
      this.factPackageTypeForm.controls.packageTypeJson.patchValue(
        packageDetails,
        {
          emitEvent: false,
        },
      );
    } else {
      this.factPackageTypeForm.controls.packageTypeJson.reset(
        {},
        { emitEvent: false },
      );
      this.factPackageTypeForm.controls.packageTypeJson.markAsDirty();
    }
    const packageCargoPlace = packageDetails?.cargoPlaceQuantityJson.find(
      place => place.cargoPlaceId === this.cargoPlaceId,
    );
    this.factPackageTypeForm.controls.packageQuantityLimit.setValue(
      packageCargoPlace?.quantity ?? 0,
    );
  }

  ngOnInit() {
    this.onPackageTypeChange();
  }
}
